import { FC } from "react";
import { FormikProps } from "formik";
import { TextInput } from "components/core";

export interface AcceptPercentageFormProps {
  form: FormikProps<any>;
  labelText?: string;
}

const AcceptPercentageForm: FC<AcceptPercentageFormProps> = ({
  form,
  labelText = "Percentage to accept",
}) => {
  return (
    <div className="space-y-6">
      {" "}
      {/* Removed divide-y for cleaner spacing */}
      {/* Offer Information Section */}
      <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
        <h3 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100 mb-3">
          Offer Participation Details
        </h3>
        <dl className="space-y-2">
          {/* Display Originally Proposed Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Reinsurer's Proposed Share:
            </dt>
            <dd className="text-sm font-semibold text-primary-600 dark:text-primary-400">
              {/* Use toFixed for consistent decimal places, handle potential undefined */}
              {form.values.offered?.toFixed(4) ?? "N/A"}%
            </dd>
          </div>

          {/* Display Maximum Available Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Maximum Available Share:
            </dt>
            <dd className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {form.values.facultative_offer?.toFixed(4) ?? "N/A"}%
            </dd>
          </div>

          {/* Optional: Add Total Facultative Offer if available in form.values */}
          {/* Example:
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Total Facultative Offer:
            </dt>
            <dd className="text-sm text-gray-700 dark:text-gray-300">
              {form.values.total_fac_offer?.toFixed(4) ?? 'N/A'}%
            </dd>
          </div>
          */}
        </dl>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
          You can accept the proposed share or modify the percentage below, up
          to the maximum available share.
        </p>
      </div>
      {/* Input Section */}
      <div>
        <TextInput
          id="percentage"
          type="number"
          label={labelText} // Use the prop for flexibility
          required
          placeholder="e.g., 10.5"
          // Displaying max info within the label or helper text might be better than postText
          // postText={`Max: ${form.values.expected?.toFixed(4)}%`}
          values={form.values}
          handleChange={form.handleChange}
          handleBlur={form.handleBlur}
          errors={form.errors}
          touched={form.touched}
          min={0}
          max={form.values.expected} // Keep validation constraint
          step={0.0001} // Allow for more precise percentage input
          // inputClassName="text-right pr-10" // Align text right for numbers, adjust padding if using postText/icon
          postText="%" // Add % symbol directly after input
        />
        <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
          Enter the final percentage you wish to accept from this reinsurer.
        </p>
      </div>
    </div>
  );
};

export default AcceptPercentageForm;
